import { Injectable } from '@angular/core';
import { ParseService } from '../parse/parse.service';
import { QueryInterface } from '../parse/query-interface';
import { StorageConfiguration } from '../storage-setting/storage-configuration';


@Injectable({
    providedIn: 'root'
})

export class GetReportingToService {

    reportingToOptions: any[];
    locationOptions: any[];
    deptOptions: any[];
    orgOptions: any[];
    tenantId: any;
    industryId: any;
    tenantDepartment: any;
    tenantRole: any;

    constructor(
        private parseService: ParseService,
        private storageConfiguration: StorageConfiguration,
        private queryInterface: QueryInterface
    ) {
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
        this.industryId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.industryId);
    }

    async getReportingTo() {

        let profileInstance = this.parseService.instance.Object.extend('Profile');
        let profileQuery = new this.parseService.instance.Query(profileInstance);
        profileQuery.equalTo('isActive', true);
        profileQuery.include('role');
        profileQuery.limit(10000);
        profileQuery.equalTo('tenantId', this.tenantId);
        let profileResults = await profileQuery.find();

        let reportingToDD = [];
        let reportingList = [];
        let queryInstance = this.parseService.instance.Object.extend('_Role');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('reportingTo', true);
        query.equalTo('isActive', true);
        let resutls = await query.find();
        for (const element of resutls) {
            let data = profileResults.filter(x => x.get('role').id == element.id);
            for (const innerelement of data) {
                let reporteeId = innerelement.id;
                let reportee = innerelement.get('firstName') + ' ' + innerelement.get('lastName');
                reportingToDD.push({ id: reporteeId, name: reportee });
                let reporting = reportingToDD;
                for (let i = 0; i < reporting.length; i++) {
                    reportingList.push(reporting[i].name);
                }
                let result = this.uniqBy(reportingToDD, JSON.stringify);
                reportingToDD = result.sort((a, b) => a.name.localeCompare(b.name));
                this.reportingToOptions = this.bindDropDown(reportingToDD);
            }
        }
        return this.reportingToOptions;
    }

    async getLocation() {
        let result = [];
        let locationDD = [];
        let queryInstance = this.parseService.instance.Object.extend('Location');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('isActive', true);
        query.ascending('name');
        query.equalTo('tenantId', this.tenantId);
        let results = await query.find();
        for (let i = 0; i < results.length; i++) {
            let jsonText = JSON.stringify(results[i]);
            let departmentInfo = JSON.parse(jsonText);
            result.push({ name: departmentInfo.name, id: departmentInfo.objectId });
        }
        locationDD = result;
        this.locationOptions = this.bindDropDown(locationDD);
        return this.locationOptions;
    }

    // async getDepartment() {
    //     let result = [];
    //     let deptDD = [];
    //     let queryInstance = this.parseService.instance.Object.extend('Department');
    //     let query = new this.parseService.instance.Query(queryInstance);
    //     query.equalTo('isActive', true);
    //     query.equalTo('industry', { __type: 'Pointer', className: 'Industry', objectId: this.industryId });
    //     query.ascending('name');
    // query.equalTo('tenantId', this.tenantId);
    //     let results = await query.find();
    //     for (let i = 0; i < results.length; i++) {
    //         let jsonText = JSON.stringify(results[i]);
    //         let departmentInfo = JSON.parse(jsonText);
    //         result.push({ name: departmentInfo.name, id: departmentInfo.objectId });
    //     }
    //     deptDD = result;
    //     this.deptOptions = this.bindDropDown(deptDD);
    //     return this.deptOptions;
    // }

    async getTenantRole(tenantId): Promise<void> {
        const TenantRoleClass = this.parseService.instance.Object.extend('TenantRole');
        const tenantRoleQuery = new this.parseService.instance.Query(TenantRoleClass);
        tenantRoleQuery.equalTo('tenantId', tenantId);
        const tenantRoleResult = await tenantRoleQuery.find();
        if (tenantRoleResult.length > 0) {
            //   return TenantRoleResult[0].get('displayName');
            this.tenantRole = tenantRoleResult;
        }
        return this.tenantRole;
    }

    getRoleDisplayName(roleName): any {
        const tenantRole = this.tenantRole.find((role) => role.get('name') === roleName);
        return tenantRole !== undefined ? tenantRole.get('displayName') : '';
    }

    async getTenantDepartment(tenantId): Promise<void> {
        const TenantDepartmentClass = this.parseService.instance.Object.extend('TenantDepartment');
        const tenantDepartmentQuery = new this.parseService.instance.Query(TenantDepartmentClass);
        tenantDepartmentQuery.ascending('name');
        tenantDepartmentQuery.include('department');
        tenantDepartmentQuery.equalTo('tenantId', tenantId);
        const tenantDepartmentResult = await tenantDepartmentQuery.find();
        if (tenantDepartmentResult.length > 0) {
            this.tenantDepartment = tenantDepartmentResult;
        }
        return this.tenantDepartment;
    }

    getDepartmentDisplayName(departmentName): any {
        const tenantDepartment = this.tenantDepartment.find((department) => department.get('department').get('name') === departmentName);
        return tenantDepartment !== undefined ? tenantDepartment.get('displayName') : '';
    }

    async getDepartment() {
        let result = [];
        let deptDD = [];
        let queryInstance = this.parseService.instance.Object.extend('TenantDepartment');
        let query = new this.parseService.instance.Query(queryInstance);
        query.ascending('name');
        query.equalTo('tenantId', this.tenantId);
        let results = await query.find();
        if (results.length > 0) {
            for (let department of results) {
                result.push({
                    id: department.get('department').id,
                    name: department.get('displayName'),
                });
            }
            deptDD = result;
            this.deptOptions = this.bindDropDown(deptDD);
            return this.deptOptions;
        }
        else {
            let queryInstance = this.parseService.instance.Object.extend('Department');
            let query = new this.parseService.instance.Query(queryInstance);
            query.equalTo('isActive', true);
            query.ascending('name');
            let results = await query.find();
            for (let i = 0; i < results.length; i++) {
                let jsonText = JSON.stringify(results[i]);
                let departmentInfo = JSON.parse(jsonText);
                result.push({
                    id: departmentInfo.objectId,
                    name: departmentInfo.name
                });
            }
            deptDD = result;
            this.deptOptions = this.bindDropDown(deptDD);
            return this.deptOptions;
        }
    }

    async getOrganisation() {
        let result = [];
        let organizationDD = [];
        let queryInstance = this.parseService.instance.Object.extend('Organisation');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('isActive', true);
        query.ascending('name');
        query.equalTo('tenantId', this.tenantId);
        let results = await query.find();
        for (let i = 0; i < results.length; i++) {
            let jsonText = JSON.stringify(results[i]);
            let organizationInfo = JSON.parse(jsonText);
            result.push({ name: organizationInfo.name, id: organizationInfo.objectId });
        }
        organizationDD = result;
        this.orgOptions = this.bindDropDown(organizationDD);
        return this.orgOptions;
    }

    uniqBy(a, key) {
        var index = [];
        return a.filter(function (item) {
            var k = key(item);
            return index.indexOf(k) >= 0 ? false : index.push(k);
        });
    }

    bindDropDown(array: any[]): any[] {
        const dropDownItem = [];
        array.forEach(a => {
            dropDownItem.push({ label: a.name, value: a.id });
        });
        return dropDownItem;
    }

}
